import React, { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { LanguageSwitcher } from "gatsby-plugin-i18n-l10n";
import { Locale } from "../types/translations";

const languageFlags: Record<Locale, string> = {
  en: "🇺🇸",
  de: "🇩🇪",
  ro: "🇷🇴",
};

interface CurrentLanguageProps {
  locale: string;
}

const LanguageSelector: React.FC = ({ position }: { position?: string }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const CurrentLanguage: React.FC<CurrentLanguageProps> = ({ locale }) => (
    <div className="flex items-center gap-2">
      <span className="text-xl">{languageFlags[locale as Locale] || "🌐"}</span>
      <span className="hidden md:flex md:font-medium">
        {intl.formatMessage({ id: `languages.${locale}` })}
      </span>
    </div>
  );

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 md:w-40 rounded-lg hover:bg-gray-100"
      >
        <CurrentLanguage locale={intl.locale} />
      </button>

      {isOpen && (
        <div
          className={`absolute mt-1 w-40 bg-white rounded-lg shadow-lg border border-gray-200 
          [&_ul]:list-none [&_ul]:m-0 [&_li]:m-0
          ${position ? "bottom-[100%]" : ""}`}
        >
          <LanguageSwitcher
            // @ts-ignore
            resolveLanguageName={(locale: string) => (
              <div className="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 w-full">
                <span className="text-xl">
                  {languageFlags[locale as Locale] || "🌐"}
                </span>
                <span className="font-medium">
                  {intl.formatMessage({ id: `languages.${locale}` })}
                </span>
              </div>
            )}
            onClick={() => setIsOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
